const AvailableBookingEmployeeReducer =  (state = { loader: false, result: [], error: null }, action) => {
    switch (action.type) {
      case 'EMPLOYEE_BOOKING_LIST_BEGINS':
        return {
          loader: true,
          result: {},
          error: null,
        };
      case 'EMPLOYEE_BOOKING_LIST_SUCCESS':
        return {
          loader: false,
          result: action.payload,
          error: null,
        };
      case 'EMPLOYEE_BOOKING_LIST_FAILURE':
        return {
          loader: false,
          result: {},
          error: action.payload,
        };
      case 'EMPLOYEE_BOOKING_LIST_RESET':
        return {
          loader: false,
          result: {},
          error: null,
        };
      default:
        return state;
    }
  };

  export default AvailableBookingEmployeeReducer;